import React from 'react';

export type ModalDocumentActionButtonsProps = {
  onSavePdf: () => void;
  onSaveExcel?: () => void;
  onPrint: () => void;
  onClose?: () => void;
  saveDisabled?: boolean;
  saveExcelDisabled?: boolean;
  printDisabled?: boolean;
  busy?: boolean;
};

const DownloadIcon: React.FC = () => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" aria-hidden>
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M3 16.5v2.25A2.25 2.25 0 005.25 21h13.5A2.25 2.25 0 0021 18.75V16.5M16.5 12L12 16.5m0 0L7.5 12m4.5 4.5V3"
    />
  </svg>
);

type DocumentDownloadButtonProps = {
  label: string;
  onClick: () => void;
  disabled: boolean;
};

const DocumentDownloadButton: React.FC<DocumentDownloadButtonProps> = ({ label, onClick, disabled }) => (
  <div className="cp-modal-document-action-wrap">
    <button
      type="button"
      className="cp-modal-document-action-btn"
      onClick={onClick}
      disabled={disabled}
      aria-label={label}
    >
      <DownloadIcon />
    </button>
    <span className="cp-modal-document-action-tooltip" role="tooltip">
      {label}
    </span>
  </div>
);

const ModalDocumentActionButtons: React.FC<ModalDocumentActionButtonsProps> = ({
  onSavePdf,
  onSaveExcel,
  onPrint,
  onClose,
  saveDisabled = false,
  saveExcelDisabled = false,
  printDisabled = false,
  busy = false,
}) => {
  const disabled = busy;
  return (
    <div className="cp-modal-document-actions">
      {onSaveExcel ? (
        <DocumentDownloadButton
          label="xls 다운"
          onClick={onSaveExcel}
          disabled={disabled || saveExcelDisabled}
        />
      ) : null}
      <DocumentDownloadButton
        label="pdf 다운"
        onClick={onSavePdf}
        disabled={disabled || saveDisabled}
      />
      <button
        type="button"
        className="cp-modal-document-action-btn"
        onClick={onPrint}
        disabled={disabled || printDisabled}
        title="프린트"
        aria-label="프린트"
      >
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" aria-hidden>
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M6.72 13.829c-.24.03-.48.062-.72.096m.72-.096a42.415 42.415 0 0110.56 0m-10.56 0L6.34 18m10.94-4.171c.24.03.48.062.72.096m-.72-.096L17.66 18m0 0l.229 2.523a1.125 1.125 0 01-1.12 1.227H7.231c-.662 0-1.18-.568-1.12-1.227L6.34 18m11.318 0h1.091A2.25 2.25 0 0021 15.75V9.456c0-1.081-.768-2.015-1.837-2.175a48.055 48.055 0 00-1.913-.247M6.34 18H5.25A2.25 2.25 0 013 15.75V9.456c0-1.081.768-2.015 1.837-2.175a48.041 48.041 0 011.913-.247m10.5 0a48.536 48.536 0 00-10.5 0m10.5 0V3.375c0-.621-.504-1.125-1.125-1.125h-8.25c-.621 0-1.125.504-1.125 1.125v3.659M18 10.5h.008v.008H18V10.5zm-3 0h.008v.008H15V10.5z"
          />
        </svg>
      </button>
      {onClose ? (
        <button
          type="button"
          className="cp-modal-document-close-btn"
          onClick={onClose}
          disabled={disabled}
          title="닫기"
          aria-label="닫기"
        >
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={2} stroke="currentColor" aria-hidden>
            <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
          </svg>
        </button>
      ) : null}
    </div>
  );
};

export default ModalDocumentActionButtons;
